import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setPublicationsList } from 'Workspace/Publications/store/actions';
import { pushToast } from 'containers/ToastManager/actions';
import { sortByDate } from 'Workspace/Publications/utils';
import catchErrors from 'utils/commands/catchErrors';
import workspaceService from 'services/WorkspaceService';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection) {
  const workspacePublicationsList = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_PUBLICATION_ACTIVITY_FETCH,
    workspaceId: workspaceService.getSelectedWorkspaceId(),
  });
  if (workspacePublicationsList.type === constants.RTM_PUBLICATION_ACTIVITY_FETCH_OK) {
    const publications = sortByDate(workspacePublicationsList.response.activities);
    yield put(setPublicationsList(publications));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspacePublicationsList} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PUBLICATIONS_LIST, catchErrors, sendRequest, connection);
}
